import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { useState } from 'react';

dayjs.extend(utc);

export const StationMoveDialog = ({
    open,
    onClose,
    onConfirm,
    currentLocationLabel,
    targetLocationLabel,
}: {
    open: boolean;
    onClose: () => void;
    onConfirm: (params: { effectiveDateIso: string }) => void;
    currentLocationLabel?: string;
    targetLocationLabel?: string;
}) => {
    const [effectiveDate, setEffectiveDate] = useState<Date>(dayjs().toDate());
    const [submitting, setSubmitting] = useState(false);

    const handleConfirm = async () => {
        setSubmitting(true);
        const effectiveDateIso = dayjs(effectiveDate).startOf('day').utc().toDate().toISOString();
        onConfirm({ effectiveDateIso });
        setSubmitting(false);
    };

    return (
        <Dialog open={open} onClose={() => onClose()}>
            <DialogTitle variant='h4'>Schedule Station Move</DialogTitle>
            <DialogContent>
                <Typography>
                    Select an effective date for moving this station
                    {currentLocationLabel && targetLocationLabel
                        ? ` from ${currentLocationLabel} to ${targetLocationLabel}`
                        : ''}
                    . If the date is today or in the past, the move will execute immediately on save.
                </Typography>

                <Box mt={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label='Effective Date'
                            value={effectiveDate}
                            onChange={(date) => setEffectiveDate(date!.toDate())}
                            renderInput={(params) => <TextField {...params} />}
                            minDate={dayjs().startOf('month')}
                            maxDate={dayjs().add(2, 'month')}
                        />
                    </LocalizationProvider>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button sx={{ textTransform: 'none' }} onClick={() => onClose()}>
                    Cancel
                </Button>
                <Button
                    sx={{ textTransform: 'none' }}
                    variant='contained'
                    disabled={submitting}
                    onClick={handleConfirm}>
                    {submitting ? 'Scheduling...' : 'Schedule Move'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
